var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"inline-block py-1 px-3 focus:outline-none",class:{
    'bg-gray-100 hover:bg-gray-100 cursor-default': _vm.$attrs.disabled,
    'hover:bg-blue-400': !_vm.$attrs.disabled,
    'bg-blue-400': _vm.active,
    'bg-white': !_vm.active,
  },attrs:{"disabled":_vm.$attrs.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }